import { createContext, useContext, useState } from "react";

const ChartSettingsContext = createContext({
  timeRange: "90d",
  setTimeRange: (timeRange: string) => {},
});

export const ChartSettingsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [timeRange, setTimeRange] = useState("90d");
  return (
    <ChartSettingsContext.Provider value={{ timeRange, setTimeRange }}>
      {children}
    </ChartSettingsContext.Provider>
  );
};

export const useChartSettings = () => {
  const context = useContext(ChartSettingsContext);
  if (!context) {
    throw new Error(
      "useChartSettings must be used within a ChartSettingsProvider"
    );
  }
  return context;
};
